import { PresetId } from '@account/account-portal/config'
import { useDevice, useMfResource } from '@crystal/core'
import { FC } from 'react'

import { BannerImageMap, DefaultBannerImage } from './assetsConfig'
import styles from './portal-layout.module.scss'

type BannerImageProps = {
  presetId: PresetId
}

export const BannerImage: FC<BannerImageProps> = ({ presetId }) => {
  const { getResourceUrl } = useMfResource()
  const { isMobile } = useDevice()
  const bannerImage = BannerImageMap[presetId] ?? DefaultBannerImage
  const shouldRenderImage = bannerImage.desktop && bannerImage.mobile

  return shouldRenderImage ? (
    <img
      className={styles[`banner-${presetId}`] || styles[`banner-default`]}
      alt="top-image"
      src={getResourceUrl(isMobile ? bannerImage.mobile : bannerImage.desktop)}
    />
  ) : null
}
